var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 25.8891L54.1012 29.0799L50.2914 26.1761V34.1109H45.6902V33.4187C45.6902 30.0422 45.6902 26.615 45.6902 23.2047C45.6935 22.9163 45.5748 22.6379 45.3589 22.4281C40.2699 18.5029 35.2086 14.603 30 10.6609L26.7239 13.1933L14.9632 22.1327C14.7454 22.2749 14.571 22.466 14.4566 22.6877C14.3422 22.9093 14.2917 23.1542 14.3098 23.3989C14.3098 32.1047 14.3098 40.8049 14.3098 49.4995V50.5547H18.7362V40.3322H25.4908V50.6222H34.454V54.75H9.77301V26.1339L5.89877 29.0799L3 25.8975L30 5.25L57 25.8891Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9448 42.4088H39V46.5113H56.9448V42.4088Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2178 27.991H30.0184V34.1194H41.2178V27.991Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4632 50.6644H39V54.7416H52.4632V50.6644Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4724 27.9825H18.773V34.1109H25.4724V27.9825Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1994 17.6672H27.7914V21.7613H32.1994V17.6672Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTva);
export default __webpack_public_path__ + "static/media/icon-tva.87955b116fad91a72f6ade4bd366522c.svg";
export { ForwardRef as ReactComponent };